<template>
  <div class="container-fluid pb-4 f14 color-black">
    <div class="row mb-4">
      <div class="col-lg-12 col-xs-12">
        <h2 class="mt-3">FORMAÇÃO ACADÊMICA</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8 col-xs-12">
        <span class="font-weight-bold ml-2 mb-2">CURSO</span>
        <span class="color-red font-weight-bold">*</span>
        <div>
          <VueSuggestion
            searchURL="/study_areas"
            style="text-transform: capitalize"
            responseDataName="study_areas"
            v-model="study_area.name"
            :selectedEl="study_area"
            :whenSelected="
              (item) => {
                study_area = item;
              }
            "
            placeholder="ENGENHEIRO, WEB DESIGNER, EDUCADOR, ETC..."
            classes="mt-1"
          />
        </div>
      </div>
      <div class="col-lg-4 col-xs-12">
        <span class="font-weight-bold ml-2 mb-2">CIDADE</span>
        <span class="color-red font-weight-bold">*</span>
        <VueSuggestion
          searchURL="/cities"
          responseDataName="cities"
          :focusOut="hasCity"
          :selectedEl="city"
          :whenSelected="setCity"
          :disabled="is_city_other_country"
          placeholder="SELECIONE UMA CIDADE"
          classes="mt-1 mb-2"
        />
        <input
          type="checkbox"
          name="selectCandidate"
          :value="is_city_other_country"
          v-model="is_city_other_country"
        />
        <span class="font-weight-bold" > Exterior </span>
        <input
          v-if="is_city_other_country"
          type="text"
          class="vs__input mt-2"
          placeholder="CIDADE"
          v-model="city_other_country"
          @focus="errors.city_other_country = false"
          :class="{ 'is-invalid': errors.city_other_country }"
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-lg-8 col-xs-12">
        <span class="font-weight-bold ml-2 mb-2">INSTITUIÇÃO DE ENSINO</span>
        <span class="color-red font-weight-bold">*</span>
        <VueSuggestion
          searchURL="/institutions"
          style="text-transform: capitalize"
          responseDataName="institutions"
          v-model="institution.name"
          :selectedEl="institution"
          :whenSelected="
            (item) => {
              institution = item;
            }
          "
          placeholder="INSTITUIÇÃO QUE VOCÊ ESTUDOU..."
          classes="mt-1"
        />
      </div>
      <div class="col-lg-4 col-xs-12">
        <span class="font-weight-bold">FORMAÇÃO</span>
        <span
          v-if="job.require_formation_type"
          class="color-red font-weight-bold"
        >
          *
        </span>
        <div class="select nav-tabs mt-1 p-0 block_info_white d-flex align-items-center">
          <select
            v-model="formation"
            class="form-control"
          >
            <option
              v-for="formation in formationsType"
              :key="formation.value"
              :value="formation.value"
            >
              {{ formation.text }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-lg-3 col-xs-12">
        <span
          class="font-weight-bold"
          :class="{ 'text-danger': errors.start_date }"
        >
          DATA DE INÍCIO
        </span>
        <span class="color-red font-weight-bold">*</span>
        <div class="vs__input-group mt-1">
          <input
            type="text"
            class="vs__input"
            v-mask="['##/####']"
            placeholder="mês/ano"
            v-model="start_date"
            @focus="errors.start_date = false"
            :class="{ 'is-invalid': errors.start_date }"
          />
        </div>
      </div>
      <div class="col-lg-4 col-xs-12 ">
        <span
          class="font-weight-bold text-nowrap mt-2"
          :class="{ 'text-danger': errors.end_date }"
        >
          DATA DE TÉRMINO OU PREVISÃO DE TÉRMINO
        </span>
        <span class="color-red font-weight-bold">*</span>
        <div class="vs__input-group mt-1">
          <input
            type="text"
            class="vs__input"
            v-mask="['##/####']"
            placeholder="mês/ano"
            v-model="end_date"
            @focus="errors.end_date = false"
            :class="{ 'is-invalid': errors.end_date }"
          />
        </div>
        <div class="mt-2">
          <SwitchCheckbox
            v-model="studying_here"
            :value="studying_here"
            label="AINDA ESTUDA NESSA INSTITUIÇÃO?"
          />
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-lg-6">
        <label class="font-weight-bold">
          SUA MÉDIA NA INSTITUIÇÃO (ESCALA DE 0 A 10)
        </label>
        <span
          v-if="job.require_average_point"
          class="color-red font-weight-bold"
        >
          *
        </span>
        <input
          class="form-control"
          :type="'number'"
          placeholder="0,0"
          min=0
          max=10
          v-model="average_point"
        />
        <span
          class="f12 color-grey-primary to_uppercase"
        >
          (Esse dado será checado posteriormente mediante pedido de histórico escolar)
        </span>
      </div>
      <div class="col-lg-6">
        <label class="font-weight-bold">
          BOLSA DE ESTUDOS
        </label>
        <span
          v-if="job.require_scholarship"
          class="color-red font-weight-bold"
        >
          *
        </span>
        <div class="row">
          <div class="col-lg-12">
            <input
              type="radio"
              name="has_scholarship"
              v-model="has_scholarship"
              :value="0"
              style="vertical-align: super"
            />
            <label class="mr-2">
              N/A
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <input
              type="radio"
              name="has_scholarship"
              v-model="has_scholarship"
              :value="1"
            />
            <label class="mr-2">
              Parcial
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <input
              type="radio"
              name="has_scholarship"
              v-model="has_scholarship"
              :value="2"
            />
            <label class="mr-2">
              Completa
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-lg-12 col-xs-12">
        <span class="font-weight-bold">Comente sobre sua formação/bolsa, caso queira</span>
        <div class="mt-1">
          <textarea
            style="height: 100px; border-radius: 5px"
            class="full form-control"
            v-model="description"
            cols="30"
            rows="10"
          ></textarea>
        </div>
      </div>
      <div class="col-lg-12 col-xs-12 mt-2">
        <button
          class="btn-add-items-tb bg-purple color-white right"
          style="min-width: 300px"
          @click="createOrUpdate()"
        >
          SALVAR
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VueSuggestion from "components/VueSuggestion.vue";
import { mask } from "vue-the-mask";
import { format, min } from "date-fns";
import axios from "axios";
import SwitchCheckbox from "../../../../pages/Recruiters/Jobs/SwitchCheckbox.vue";

export default {
  props: ["education_id", "candidate_id", "account_uid", "job"],
  components: { VueSuggestion, SwitchCheckbox },
  mounted() {
    if (this.education_id) {
      let url = `/candidates/educations/${this.education_id}`;
      if (this.candidate_id) {
        url = `/recruiters/talent_banks/educations/${this.education_id}`;
      }
      axios.get(url).then((response) => {
        let education = response.data.education;

        this.study_area.id = education.study_area_id;
        this.study_area.name = education.study_area_name.toLowerCase();
        this.institution.id = education.institution_id;
        this.institution.name = education.institution_name.toLowerCase();
        this.start_date = education.start_date
          ? format(new Date(education.start_date), "MM/yyyy")
          : "";
        this.end_date = education.end_date
          ? format(new Date(education.end_date), "MM/yyyy")
          : "";
        this.city.id = education.city_id;
        this.city.name = education.city_id
          ? education.city_name + " / " + education.state_uf
          : "";
        this.formation = education.formation_type;
        this.description = education.description;
        this.studying_here = education.studying_here;
        this.average_point = education.average_point;
        this.has_scholarship = education.has_scholarship;
        this.is_city_other_country = education.city_other_country ? true : false;
        this.city_other_country = education.city_other_country || null;
      });
    }
  },
  data: () => ({
    start_date: "",
    end_date: "",
    description: "",
    studying_here: false,
    formation: 0,
    average_point: null,
    has_scholarship: null,
    is_city_other_country: false,
    city_other_country: null,
    institution: {
      id: 0,
      name: "",
    },
    study_area: {
      id: 0,
      name: "",
    },
    city: {
      id: 0,
      name: "",
    },
    formationsType: [
      { value: 0, text: "Colegial" },
      { value: 1, text: "Curso Técnico" },
      { value: 2, text: "Treinamento" },
      { value: 3, text: "Graduação" },
      { value: 4, text: "Iniciação Cientifica" },
      { value: 5, text: "Pós-Graduação" },
      { value: 6, text: "Mestrado" },
      { value: 7, text: "Doutorado" },
      { value: 8, text: "Phd" },
      { value: 9, text: "Outros" },
    ],
    errors: {
      start_date: false,
      end_date: false,
    },
  }),
  computed: {
    params() {
      let educations = {
        description: this.description,
        candidate_id: this.candidate_id,
        start_date: this.formatDate(this.start_date),
        end_date: this.formatDate(this.end_date),
        study_area: this.study_area.name.toLowerCase(),
        studying_here: this.studying_here,
        institution: this.institution.name.toLowerCase(),
        formation_type: this.formation,
        city_id: this.city.id === 0 ? null : this.city.id,
        average_point: this.average_point,
        has_scholarship: this.has_scholarship,
        city_other_country: this.city_other_country,
        account_id: this.account_uid,
      };
      return educations;
    },
  },
  methods: {
    setCity(event) {
      this.city.id = event.id;
      this.city.name = event.title;
      this.city_other_country = null;
    },
    createOrUpdate() {
      if (!this.validForm()) return;
      if (!this.validDate(this.start_date, "start_date")) return;
      if (!this.validDate(this.end_date, "end_date")) return;

      if (this.education_id) {
        this.updateExperience();
        return;
      }

      this.createExperience();
    },
    createExperience() {
      let url = `/candidates/educations/`;
      if (this.candidate_id) {
        url = `/recruiters/talent_banks/educations/`;
      }
      axios
        .post(url, {
          educations: this.params,
        })
        .then((response) => {
          this.sendFeedback(response.data.status);
        });
    },
    updateExperience() {
      let url = `/candidates/educations/${this.education_id}`;
      if (this.candidate_id) {
        url = `/recruiters/talent_banks/educations/${this.education_id}`;
      }
      axios
        .put(url, {
          educations: this.params,
        })
        .then((response) => {
          this.sendFeedback(response.data.status);
        });
    },
    sendFeedback(status) {
      if (!status) {
        this.$toast.error("Sinto muito, não foi possivel salvar.");
        return;
      }

      this.$toast.success("Formação acadêmica salva com sucesso!");
      eventBus.$emit("getEducations");
      eventBus.$emit("updateInfo");
      this.$modal.hideAll();
    },
    validForm() {
      let fields = [
        { name: "Curso", value: this.study_area.name },
        { name: "Instituição de ensino", value: this.institution.name },
        { name: "Ano de inicio", value: this.start_date },
        { name: "Ano de término", value: this.end_date },
      ];

      if (this.city_id === 0) this.city_id = null;

      if (!this.city.id && !this.is_city_other_country) {
        this.$toast.error(`O campo "Cidade" não pode ficar vazio.`);
        return false;
      }

      if (this.average_point < 0 || this.average_point > 10) {
        this.$toast.error(`O campo Média deve ser um número entre 0 e 10.`);
        return false;
      }

      if (this.is_city_other_country && !this.city_other_country) {
        this.$toast.error(`O campo "Cidade" não pode ficar vazio.`);
        return false;
      }

      if (
        this.job.require_formation_type &&
        this.formation !== 0 &&
        !this.formation
      ) {
        this.$toast.error(`O campo "Tipo de formação" não pode ficar vazio.`);
        return false;
      }

      if (
        this.job.require_scholarship &&
        this.has_scholarship !== 0 &&
        !this.has_scholarship
      ) {
        this.$toast.error(`O campo "Bolsas de estudos" não pode ficar vazio.`);
        return false;
      }

      if (
        this.job.require_average_point &&
        !this.average_point &&
        this.average_point !== 0
      ) {
        this.$toast.error(`O campo "Média na instituição" não pode ficar vazio.`);
        return false;
      }

      for (let field of fields) {
        if (field.value.length === 0) {
          this.$toast.error(`O campo "${field.name}" não pode ficar vazio.`);
          return false;
        }
      }

      return true;
    },
    validDate(dateStr, field) {
      if (dateStr.length === 0) {
        this.$toast.error("Por favor, preencha o campo corretamente.");
        this.errors[field] = true;
        return false;
      }

      let month = parseInt(dateStr.slice(0, dateStr.indexOf("/")));
      let year = dateStr.slice(dateStr.indexOf("/") + 1);

      if (field === 'start_date') {
        const start_date = new Date(year, month-1, '01');
        const today = new Date();
        if (start_date > today) {
          this.errors[field] = true;
          return false
        }
      }

      if (month === 0 || month > 12) {
        this.$toast.error("Data invalida.");
        this.errors[field] = true;
        return false;
      }

      if (year <= 1960 || year >= 2050) {
        this.$toast.error("Data invalida, insira um ano valido.");
        this.errors[field] = true;
        return false;
      }

      return true;
    },
    formatDate(dateStr) {
      let month = dateStr.slice(0, dateStr.indexOf("/"));
      let year = dateStr.slice(dateStr.indexOf("/") + 1);

      return year.concat("/", month, "/01");
    },
    hasCity(event, items, select) {
      if(select){
        this.city.id = select.id;
        this.city.name = select.name;
      }else{
        this.city = items[0] ? items[0] : { id: 0, name: "" };
      }
      if (!this.city)
        this.$toast.error("Por favor, informe a cidade de candidato(a).");
    }
  },
};
</script>

<style>
@media (max-width: 768px) {
  .vm--modal{
    top: 80px !important;
    left: 0!important;
    max-height: 70vh;
    overflow-y: auto !important;
    width: 90vw !important;
    position: relative;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>